import React from 'react';
import { getContext } from 'common';
import Typography, { TypographyProps } from 'components/Typography';
import _merge from 'lodash/merge';
import Styled from './styles';

export interface CoachmarkCountProps extends React.ComponentPropsWithRef<'div'> {
  /** Content is placed here. */
  children: React.ReactNode;
  /** The Typography configuration. See `<Typography/>` documentation for more. */
  typographyProps?: Partial<TypographyProps>;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Coachmark count component shows the number of screens from the current tour.
 * All additional props will be forwarded to the root element.
 */
const CoachmarkCount = React.forwardRef<HTMLElement, CoachmarkCountProps>((props: CoachmarkCountProps, ref) =>
  getContext(({ RTL, theme: globalTheme }) => {
    const {
      children, typographyProps, theme, ...otherProps
    } = props;
    const resolvedTheme = _merge({}, globalTheme.COACHMARKS, theme);

    return (
      <Styled.CoachmarkCount $rtl={RTL} ref={ref} $theme={resolvedTheme} {...otherProps}>
        <Typography variant="LABEL" style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', color: resolvedTheme.count }}>
          {children}
        </Typography>
      </Styled.CoachmarkCount>
    );
  }));

CoachmarkCount.defaultProps = {
  typographyProps: {},
  theme: {}
};
CoachmarkCount.displayName = 'CoachmarkCount';
export { CoachmarkCount as default };
